/** Tracks palette drag for canvas hit-testing (getData is often empty during dragover). */
let activeCategory: string | null = null;

export function setPaletteDragCategory(category: string | null): void {
  activeCategory = category;
}

export function getPaletteDragCategory(): string | null {
  return activeCategory;
}
